/**
 * Shared Tailwind class strings for formula builder chips.
 * Used by commissions FormulaTab and settings FormulaSettingEditor.
 */
export const exprItemBase =
  "inline-flex items-center gap-2 max-w-full rounded-control text-sm px-2.5 py-1.5";

export const operatorBtn =
  "border border-border rounded-control bg-white cursor-pointer font-extrabold min-h-11 px-2.5 py-1.5 hover:bg-slate-50";

export const fieldBtn =
  "flex flex-col gap-1 text-right border border-border rounded-control bg-white cursor-pointer font-extrabold min-h-11 px-2.5 py-1.5 hover:bg-indigo-50";
